import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  Label,
} from "@fluentui/react-components";
import * as React from "react";
import { useCallback, useState } from "react";

interface NotificationsActionsProps {
  hasSelection: boolean;
  hasNotifications: boolean;
  selectedCount: number;
  allNotificationsCount: number;
  actionsClassName: string;
  actionLabelClassName: string;
  onConfirmDismissSelected: () => void;
  onConfirmClearAll: () => void;
}

const NotificationsActions: React.FC<NotificationsActionsProps> = ({
  hasSelection,
  hasNotifications,
  selectedCount,
  allNotificationsCount,
  actionsClassName,
  actionLabelClassName,
  onConfirmDismissSelected,
  onConfirmClearAll,
}) => {
  const [isDismissDialogOpen, setIsDismissDialogOpen] = useState(false);
  const [isClearAllDialogOpen, setIsClearAllDialogOpen] = useState(false);

  const handleDismissSelectedClick = useCallback(() => {
    if (!hasSelection) {
      return;
    }

    setIsDismissDialogOpen(true);
  }, [hasSelection]);

  const handleConfirmDismissSelected = useCallback(() => {
    onConfirmDismissSelected();
    setIsDismissDialogOpen(false);
  }, [onConfirmDismissSelected]);

  const handleCloseDismissDialog = useCallback(() => {
    setIsDismissDialogOpen(false);
  }, []);

  const handleClearAllClick = useCallback(() => {
    if (!hasNotifications) {
      return;
    }

    setIsClearAllDialogOpen(true);
  }, [hasNotifications]);

  const handleConfirmClearAll = useCallback(() => {
    onConfirmClearAll();
    setIsClearAllDialogOpen(false);
  }, [onConfirmClearAll]);

  const handleCloseClearAllDialog = useCallback(() => {
    setIsClearAllDialogOpen(false);
  }, []);

  return (
    <>
      <div className={actionsClassName}>
        <Label
          className={actionLabelClassName}
          style={{
            opacity: hasSelection ? 1 : 0.4,
            cursor: hasSelection ? "pointer" : "default",
          }}
          onClick={hasSelection ? handleDismissSelectedClick : undefined}
        >
          Dismiss Selected
        </Label>
        <Label
          className={actionLabelClassName}
          style={{
            opacity: hasNotifications ? 1 : 0.4,
            cursor: hasNotifications ? "pointer" : "default",
          }}
          onClick={hasNotifications ? handleClearAllClick : undefined}
        >
          Clear All
        </Label>
      </div>

      <Dialog
        modalType="alert"
        open={isDismissDialogOpen}
        onOpenChange={(_, data) => setIsDismissDialogOpen(data.open)}
      >
        <DialogSurface>
          <DialogBody>
            <DialogTitle>Dismiss Notifications</DialogTitle>
            <DialogContent>
              {selectedCount} notifications will be dismissed. Do you wish to
              continue?
            </DialogContent>
            <DialogActions>
              <Button
                appearance="primary"
                onClick={handleConfirmDismissSelected}
              >
                Yes
              </Button>
              <Button appearance="secondary" onClick={handleCloseDismissDialog}>
                No
              </Button>
            </DialogActions>
          </DialogBody>
        </DialogSurface>
      </Dialog>

      <Dialog
        modalType="alert"
        open={isClearAllDialogOpen}
        onOpenChange={(_, data) => setIsClearAllDialogOpen(data.open)}
      >
        <DialogSurface>
          <DialogBody>
            <DialogTitle>Clear all Notifications</DialogTitle>
            <DialogContent>
              {allNotificationsCount} notifications will be cleared from the
              Notification panel. Do you wish to continue?
            </DialogContent>
            <DialogActions>
              <Button appearance="primary" onClick={handleConfirmClearAll}>
                Yes
              </Button>
              <Button
                appearance="secondary"
                onClick={handleCloseClearAllDialog}
              >
                No
              </Button>
            </DialogActions>
          </DialogBody>
        </DialogSurface>
      </Dialog>
    </>
  );
};

export default NotificationsActions;
